const handleFormSuccess = () => {
	document.addEventListener('wpcf7mailsent', function () {
		const contestForm = document.querySelector('.register-form');

		if (!contestForm) {
			return;
		}

		const isLT = document.documentElement.lang === 'lt-LT';

		const image = `<svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="79.3672" y="59.3519" width="21.217" height="21.217" transform="rotate(97.9733 79.3672 59.3519)" fill="#F0CB69"/>
							<path d="M64.7541 17.5C58.9535 11.6343 50.9012 8 42 8C24.3269 8 10 22.3269 10 40C10 57.6731 24.3269 72 42 72C59.6731 72 74 57.6731 74 40C74 33.4786 72.0492 27.4129 68.6994 22.3545" stroke="#181B2B" stroke-width="1.5"/>
							<path d="M28.5 38.9672L38.3077 49L73.5 13" stroke="#181B2B" stroke-width="1.5"/>
						</svg>
						`;

		const imageContainer = document.createElement('div');
		imageContainer.classList.add('register-success-image');
		imageContainer.innerHTML = image;
		const successContainer = document.createElement('div');
		successContainer.classList.add('register-success');

		const successHeading = document.createElement('h2');
		successHeading.textContent = isLT
			? 'Ačiū, kad užsiregistravote!'
			: 'Thank you for registering!';

		const successText = document.createElement('p');
		successText.textContent = isLT
			? 'Per 2 darbo dienas susisieksime sutarti apsilankymo laiką.'
			: 'We will contact you within 2 business days to arrange a visit.';

		const closeButton = document.createElement('button');

		contestForm.appendChild(imageContainer);
		closeButton.textContent = isLT ? 'Uždaryti' : 'Close';
		closeButton.classList.add('erd_button');
		closeButton.setAttribute('x-on:click', 'registerModalOpen=false');

		successContainer.appendChild(imageContainer);
		successContainer.appendChild(successHeading);
		successContainer.appendChild(successText);
		successContainer.appendChild(closeButton);

		contestForm.innerHTML = '';
		contestForm.appendChild(successContainer);
	});
};

const handleCustomDropdown = () => {
	const dropdowns = document.querySelectorAll(
		'.wpcf7-form-control.wpcf7-select'
	);
	dropdowns.forEach(function (dropdown) {
		if (!dropdown.closest('.custom-dropdown-wrapper')) {
			const wrapper = document.createElement('div');
			wrapper.className = 'custom-dropdown-wrapper';
			dropdown.parentNode.insertBefore(wrapper, dropdown);
			wrapper.appendChild(dropdown);
		}
	});
};

const hiddenFieldValue = () => {
	const hiddenField = document.querySelector('input[name="campus"]');
	const campusButtons = document.querySelectorAll('[data-openapply-campus]');

	if (!hiddenField || !campusButtons.length) return;

	function changeInputVal(campusId) {
		hiddenField.value = campusId;
	}

	campusButtons.forEach((btn) => {
		btn.addEventListener('click', () => {
			const campusId = btn.dataset.openapplyCampus;

			if (campusId !== hiddenField.value) {
				changeInputVal(campusId);
			}
		});
	});
};

export const initRegisterForm = () => {
	handleFormSuccess();
	handleCustomDropdown();
	hiddenFieldValue();
};
